import { Component, OnInit, ElementRef } from '@angular/core';
import { DataService } from '../../../data.service';

@Component({
  selector: 'lc-account-image-upload',
  templateUrl: './account-image-upload.component.html',
  styleUrls: ['./account-image-upload.component.scss']
})

export class AccountImageUploadComponent implements OnInit {

  new_logo_image_to_big: boolean = false;
  new_logo_image: any;
  new_logo_preview: boolean = false;
  MIN_H: number = 200;
  MIN_W: number = 400;

  constructor(public dataService: DataService, private element: ElementRef) { }

  ngOnInit() {

  }

  logoChanged(event) {
        let reader = new FileReader();
        let image = this.element.nativeElement.querySelector('.logo-preview');
        this.new_logo_image = image;
        this.new_logo_preview = true;

        reader.onload = function(e: any) {
            let src = e.target.result;
            image.src = src;
            setTimeout(()=>{
              console.debug(image.naturalHeight);
              console.debug(image.naturalWidth);
              image.image_to_small = (image.naturalHeight < this['MIN_H'] || image.naturalWidth < this['MIN_W']);
            });
        };
        let filesize = ((event.target.files[0].size/1024)); // kB
        if(filesize < 500){
          this.new_logo_image_to_big = false;
          reader.readAsDataURL(event.target.files[0]);
        } else {
          this.new_logo_image_to_big = true;
        }

  }

  updateLogo(){
    let img_data = this.new_logo_image.src;
    this.dataService.update_logo(img_data).subscribe((success)=>{
      this.dataService.user_info.marketing_logo = img_data;
      this.new_logo_image.src = undefined;
      this.new_logo_preview = false;
      this.dataService.presentMessage('Praktijk logo aangepast', 'success');
    },
    (error) => {
      this.dataService.presentMessage('Praktijk logo upload mislukt !', 'error');
    })
  }

  resetLogo(){
      let img_data = "---";
      this.dataService.update_logo(img_data).subscribe((success)=>{
        this.dataService.user_info.marketing_logo = undefined;
        //this.new_logo_image.src = undefined;
        this.new_logo_preview = false;
        this.dataService.presentMessage('Praktijk logo verwijderd', 'success');
      },
      (error) => {
        this.dataService.presentMessage('Logo verwijderen  mislukt !', 'error');
      })
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/account-management/account-image-upload/account-image-upload.component.ts